import React from 'react';
import AssemblyResults from '../pages/AssemblyResults';

export const assemblyResultsRoutePage = {
  component: <AssemblyResults />,
  route: '/resultados-assembleia',
};
